var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.386.21a1 1 0 011.228 0l8.228 6.4A3 3 0 0120 8.98V18a2 2 0 01-2 2h-4a2 2 0 01-2-2v-6H8v6a2 2 0 01-2 2H2a2 2 0 01-2-2V8.98a3 3 0 011.16-2.37L9.386.21zM10 2.266L2.386 8.188A1 1 0 002 8.98V18h4v-6a2 2 0 012-2h4a2 2 0 012 2v6h4V8.98a1 1 0 00-.386-.792L10 2.268v-.002z",
    fill: "currentColor"
  })));
}
export default SvgHouse;